import BaseModelAPI from '../BaseModelAPI';

export default class ReportPoPembelianList extends BaseModelAPI {

	static entity = 'newreport1998list'
	static entityName = 'reportpopembelian';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
